module.exports = {
  productDetail: { // 详情页
    Product: '产品详情',
    Included: '包含的服务',
    months: '12 个月的翻新机保修',
    returns: '30 天无忧退货',
    shipping: '免费和快递',
    support: '客户关怀支持',
    replace: '如果出现缺陷，该物品可以免费维修。 如果无法修复，我们将更换。',
    Simple: '收到商品后，您有 30 天的时间对其进行试运行。 如果它不符合您的期望，请将其退回。 就那么简单。',
    Almost: '几乎所有产品都免运费。 所以你付钱买你想要的东西而不是运费。',
    resolve: '如果您有任何疑问或问题，我们的业务将在 1 个工作日内回复您。 如果他们不这样做，我们会支持您，我们会帮助您解决问题。',
    Payments: '付款 100% 安全',
    money: '30天退款保证',
    minimum: '1 年最低保修',
    Free: '免费送货所有订单',
    EMarket: '我们的合作伙伴是电子专家，他们在出厂前测试并验证每个产品的功能 100%。 这就是您在 YayTech 购买翻新设备可享受至少 1 年保修的原因。',
    Cart: '加入购物车',
    buy: '立即购买',
    Conditions: '状况',
    Fair: '公平的',
    Screen: '屏幕',
    Body: '机身：一些明显的划痕和一些不影响性能的小凹痕 ',
    Good: '好的',
    ScreenNo: '屏幕：无划痕',
    odyLight: '身体：轻微的微划痕（在手臂长度处不可见）',
    Excellent: '优秀',
    scratches: '屏幕：无划痕 ',
    invi_sible_from: '身体：就像新的，非常轻的微划痕（从 8 英寸远看不到，比标准尺寸的铅笔长一点）。',
    Brand_New: '全新的 ',
    been_activated: '密封在原盒中，设备从未激活或使用过。 屏幕或机身上的任何地方都没有划痕或痕迹。',
    All_conditions: '所有条件都 100% 完全正常运行。 状况仅指外观状况。',
    Sorry: '非常抱歉，该设备没有库存了，我们正在努力备货中。您可以去我们店铺看看其他设备，相信总会找你喜欢的。',
    Like: '你也许也喜欢'
  },
  placeOrder: { // 立即购买页面
    address: '请选择您的收货地址',
    information: '请确认订单信息',
    Payment: '付款方式',
    Shop: '店铺：',
    Product: '产品',
    Unit: '单价',
    Quantity: '数量',
    Promo: '促销信息',
    Subtotal: '小计',
    Address: '添加新地址',
    Subtotal_index: '小计',
    Shipping: '运费',
    excluding: '4个工作日（不包括处理时间）',
    Promo_Info: '销售税',
    Payout: '总支出',
    included: '含税',
    Confirm: '确认并付款',
    EMarket: '在大多数州，法律要求 YayTech 征收销售税。 税金在此页面上计算（估计），然后在付款时计算。',
    requirements: '如果您有其他要求，请备注',
    Default: '设为默认地址',
    Default_address: '默认地址',
    Next: '下一步',
    Total: '小计',
    YourOrder: '您的订单信息',
    complete: '您将被重定向到 PayPal 的网站以完成付款。待会见！',
    website: '您将被重定向到 Affirm 的网站以完成付款。待会见！'
  },
  CheckoutSuccess: { // 下单成功页
    Placed: '下单成功！',
    products: '您的产品很快就会到家。 请注意您的手机以获取通知。',
    Shopping: '继续购物 ',
    Status: '追踪订单状态'
  },
  shoppingCart: {
    home: '首页',
    myCart: '我的购物车',
    shoppingCart: '购物车',
    selectAll: '所有',
    productsName: '商品名',
    price: '价格',
    quantity: '数量',
    subtotal: '总价格',
    operating: '操作',
    checkout: '结算',
    total: '总金额'
  }
}



// WEBPACK FOOTER //
// ./src/assets/lang/zh-cn/product.js